module.exports = __webpack_public_path__ + "img/whats-new-5_en.3ee29ae.jpg";